<template>
  <v-list-item :title="hit.name" :to="url">
    <template #prepend>
      <ImageField
        :src="hit.image"
        width="80"
        aspect-ratio="1"
        class="mr-2"
        fit="cover"
      />
    </template>
    <template #subtitle>
      <span v-if="hit.store" class="text-caption">
        By
        <router-link
          :to="{
            name: 's-handle',
            params: { handle: hit.store.handle },
          }"
        >
          {{ hit.store.name }}
        </router-link>
      </span>
    </template>
    <div>
      <div class="font-weight-thin">
        <span v-if="hit.price_min < hit.price">
          From {{ formatPrice(hit.price_min) }}
        </span>
        <span v-else>{{ formatPrice(hit.price) }}</span>
      </div>

      <!-- variants -->
    </div>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { ProductResult } from "../models";

export default defineComponent({
  name: "SearchContentProductItem",
  props: {
    hit: { type: Object as PropType<ProductResult>, required: true },
  },
  computed: {
    url() {
      return {
        name: "products-handle",
        params: { handle: this.hit.handle },
      };
    },
  },
  methods: {
    formatPrice,
  },
});
</script>
